// extracted by mini-css-extract-plugin
export default {"modal":"MoveCandidateGroupModal-module__modal__fyFtY","detail":"MoveCandidateGroupModal-module__detail__R3wJs","content":"MoveCandidateGroupModal-module__content__gAxTS"};